export default "__VITE_ASSET__DwNuAGRT__"